import { ApiEndPoint } from '@/domains/api/api.entity';
import type {
  AuthCredentials,
  AuthResultApi,
  CreatePasswordPayload,
  CreatePasswordResponse,
} from '@/domains/auth/auth.entity';
import { apiRequest } from './apiRequest';

/**
 * Servicio HTTP para autenticación de usuarios
 * Responsabilidad: Comunicación con endpoints de login y creación de contraseña
 */
class AuthApiService {
  /**
   * Autentica un usuario con sus credenciales
   * @param credentials - Credenciales de acceso (usuario y contraseña)
   */
  async login(credentials: AuthCredentials): Promise<AuthResultApi> {
    const authResponse = await apiRequest.post<AuthResultApi, AuthCredentials>({
      route: ApiEndPoint.AUTH,
      payload: credentials,
    });

    return authResponse;
  }

  /**
   * Crea una nueva contraseña para un usuario
   * @param payload - Datos para creación de contraseña (RUN, contraseña temporal, nueva contraseña)
   */
  async createPassword(
    payload: CreatePasswordPayload,
  ): Promise<CreatePasswordResponse> {
    const createPassword = await apiRequest.put<
      CreatePasswordResponse,
      CreatePasswordPayload
    >({
      route: ApiEndPoint.CREATE_PASSWORD,
      payload,
    });

    return createPassword;
  }
}

export const authApiService = new AuthApiService();
